<template lang="pug">
div
  .row
    .col-12
      .component-title.d-flex.justify-content-between
        span.text {{ $t('pages.planDetails.currentPlan') }}
      .card.card--plan-details
        .card-body
          .data.d-flex.justify-content-between
            .detail.d-flex.align-items-center
              .detail-text.d-flex.flex-column 
                .type.card-title 
                  icon(:name='getPlanIcon')
                  span.text.ms-2 {{ getPlanTitle }}
                span.text.ms-4 {{ getPlanConsumptionDescriptionPeriod }}
            .actionStatus.d-flex.align-items-center
              .status
                .alert-simple(:class='planStatus.class' role='alert')
                  icon(:name='planStatus.icon' v-if='planStatus.icon')
                  span.text {{ planStatus.name }}
      ConsumptionDetails(:plan='currentPlan' :planStatus='planStatus')
</template>

<script>
import PlanName from '@/enums/PlanName';
import PlanIcon from '@/enums/PlanIcon';
import ConsumptionDetails from './ConsumptionDetails.vue';
import Icon from '@/ui/atoms/Icon.vue';
import PlanIntervalText from '@/enums/PlanIntervalText';

export default {
  name: 'PlanConsumption',
  components: {
    Icon,
    ConsumptionDetails,
  },
  props: {
    plan: Object,
    planStatus: Object,
    isPostpaid: Boolean,
  },
  async created() {
    this.$loading(true);
    try {
      this.updatePageStrings();

      const shouldRedirect = this.$route.query.autoRedirect === 'true';

      if (shouldRedirect) {
        window.history.replaceState({}, '', '/business/dashboard');
      }
    } finally {
      this.$loading(false);
    }
  },
  computed: {
    currentPlan() {
      return this.plan ?? {};
    },
    getPlanTitle() {
      const planName = this.getPlanName.toLowerCase();
      return this.$t('pages.plan.planConsumptionTitle', { planName });
    },
    getPlanName() {
      if (this.isPostpaid) {
        return this.$t('planInfo.postPaid');
      }
      const key = PlanName.getByPlanName(this.plan.name);
      return this.$t(key);
    },
    getPlanIcon() {
      if (this.isPostpaid) {
        return PlanIcon.getByName('postpaid');
      }
      return PlanIcon.getByName(this.plan.name);
    },
    getPlanIntervalText() {
      const key = PlanIntervalText.getByInterval(this.plan?.interval || 0);
      return this.$t(key, { interval: this.plan?.interval || 0 });
    },
    getPlanConsumptionDescriptionPeriod() {
      // check if subscription is_postpaid to return 'month' or 'period'
      if (this.isPostpaid) {
        const key = this.$t('pages.plan.month');
        return this.$t('pages.plan.planConsumptionDescription', {
          period: key,
        }).toLowerCase();
      }
      return this.$t('pages.planDetails.recurringCredits', {
        interval: this.getPlanIntervalText,
      }).toLowerCase();
    },
  },
  methods: {
    updatePageStrings() {
      this.$store.dispatch('page/setTitle', this.$t('pages.plan.title'));
      this.$store.dispatch('page/setHead', this.$t('pages.plan.head'));
    },
  },
};
</script>

<style scoped lang="stylus">
.skeleton-lg {
  height: 24px;
  width: 130px;
}

.skeleton-sm {
  height: 15px;
  width: 40px;
}

.skeleton-md {
  height: 15px;
  width: 50px;
}

.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
